import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiListRepository } from '@softline/core';
import { SOFTLINE_API_WORKFLOW_TYPES } from '../workflow.api';
import { WorkflowType } from '../types/workflow-type';

@Injectable()
export class WorkflowTypesRepository extends ReadonlyHttpApiListRepository<
  WorkflowType[],
  undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WORKFLOW_TYPES);
  }
}
